

import { RangeIntervalModel } from './RangeIntervalModel';
import { types } from 'mobx-state-tree';

export const RangeModel = types.model('RangeModel', {
  intervals: types.maybeNull(types.array(RangeIntervalModel)),
  stepSize: types.maybeNull(types.number),
  defaultValue: types.maybeNull(types.number),
});


